<hbo-datatable-smart *ngIf="entities$ | async as entities" [columns]="['id', 'name', 'entityType', 'parentEntity']"
  [items]="entities" (reload)="searchEntities($event)" [page]="'settings'" [typeData]="'settingsList'"
  [showTeamFilter]="user.roleId === 1 || user.roleId === 2"
  [teams_filter]="teams">
  <tbody class="table-group-divider accordion" id="accordionEntity">
    <ng-container *ngFor="let entity of entities.data">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + entity.id" (click)="open(entity.id)"> </button></th>
        <td>{{ entity.id }}</td>
        <td>{{ entity.name }}</td>
        <td>{{ entity.entityType?.name }}</td>
        <td>{{ entity.parentEntity?.name }}</td>
      </tr>
      <tr class="row-body">
        <td colspan="5" class="bg-light p-0">
          <div [id]="'collapse-' + entity.id" class="accordion-collapse collapse" data-bs-parent="#accordionEntity" #collapseElements >
            <div class="accordion-body">
              <ul class="nav nav-tabs my-4">
                <li class="nav-item">
                  <a class="nav-link" [class.active]="settingsFocused === 'web'"
                    (click)="setFocusedSettings('web',entity.id)">Web</a>
                </li>
                <li class="nav-item"
                  *ngIf="entityApps?.includes(1) || entityApps?.includes(2) || entityApps?.includes(3) || entityApps?.includes(4) || entityApps?.includes(8)">
                  <a class="nav-link" [class.active]="settingsFocused === 'mimesys'"
                    (click)="setFocusedSettings('mimesys',entity.id)">VR App</a>
                </li>
                <li class="nav-item" *ngIf="entityApps?.includes(5) || entityApps?.includes(6)">
                  <a class="nav-link"
                    [class.active]="settingsFocused === 'fit-made4u'"
                    (click)="setFocusedSettings('fit-made4u',entity.id)">
                    <span *ngIf="entityApps?.includes(5)">FIT</span>
                    <span *ngIf="entityApps?.includes(5) && entityApps?.includes(6)">/</span>
                    <span *ngIf="entityApps?.includes(6)">Made4U</span>
                  </a>
                </li>
                <li class="nav-item" *ngIf="entityApps?.includes(7)">
                  <a class="nav-link"
                    [class.active]="settingsFocused === 'fit-360depict'"
                    (click)="setFocusedSettings('fit-360depict',entity.id)">360Depict</a>
                </li>
                <!--<li>
                  <div (click)="setApps($event)"><i class="bi bi-arrow-clockwise"></i></div>
                </li>-->
              </ul>
              <hbo-setting-backoffice *ngIf="settingsFocused === 'web'" [entityId]="entityId" [entity]="entity"
                [isOpen]="isOpen(entity.id, 0)" (reload)="searchEntities()"
                (setApps)="setApps($event)" [entityApps]="entityApps"
                [standaloneAppsIds]="standaloneAppsIds"></hbo-setting-backoffice>
              <hbo-setting-mimesys *ngIf="settingsFocused === 'mimesys'" [apps]="entityApps" [entity]="entity"
                [isOpen]="isOpen(entity.id, 1)" (reload)="searchEntities()"></hbo-setting-mimesys>
              <hbo-setting-fitmade4u *ngIf="settingsFocused === 'fit-made4u'" [entity]="entity"
                [isOpen]="isOpen(entity.id, 5)" [entityApps]="entityApps"
                (reload)="searchEntities()"></hbo-setting-fitmade4u>
              <hbo-setting-360 *ngIf="settingsFocused === 'fit-360depict'" [entity]="entity"
                [isOpen]="isOpen(entity.id, 7)" (reload)="searchEntities()"></hbo-setting-360>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!entities.data.length">
      <td colspan="4" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>

<div id="loginPreview" hidden>
  <hbo-login></hbo-login>
</div>